/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiCallOut } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

import ExternalLink from '@/components/ExternalLink'

import type { FC } from 'react'

const GovCloudDualStackActivationCallout: FC = () => (
  <EuiCallOut
    title={
      <FormattedMessage
        id='portal-resources.gov-cloud-dual-stack-activation-title'
        defaultMessage='Dual-stack Connectivity for GovCloud'
      />
    }
    color='primary'
    iconType='iInCircle'
    data-test-id='gov-cloud-dual-stack-activation-callout'
  >
    <p>
      <FormattedMessage
        id='portal-resources.gov-cloud-dual-stack-activation-message'
        defaultMessage="We're enabling dual-stack (IPv4/IPv6) connectivity in GovCloud on July 28, 2025. If you operate in an IPv6-enabled environment, {action}. Learn more in {link}."
        values={{
          action: (
            <b>
              <FormattedMessage
                id='portal-resources.gov-cloud-dual-stack-activation-action'
                defaultMessage='you may need to take action'
              />
            </b>
          ),
          link: (
            <ExternalLink href='https://ela.st/dualstack-govcloud-faq'>
              <FormattedMessage
                id='portal-resources.gov-cloud-dual-stack-activation-message.link'
                defaultMessage='our knowledge base article'
              />
            </ExternalLink>
          ),
        }}
      />
    </p>
  </EuiCallOut>
)

export default GovCloudDualStackActivationCallout
